module.exports = __webpack_public_path__ + "static/full06-dd40cc11704c4d905205704568d178a9.png";